
const {Urls} = require(BUILD_ENV == "socialcare_prod" ? "./socialcare-prodConstants": BUILD_ENV == "socialcare_dr" ? "./socialcare-drConstants": BUILD_ENV == "socialcare_uat" ? "./socialcare-uatConstants": "./servelec-demoConstants")
export {
  Urls
}
